import { ConnectorActionCardType } from './connectorActionCardType';
import { CardDetails, MessageContext } from 'owa-actionable-message';
import { getCorrelationVector } from 'owa-service/lib/correlationVector';
import { getClientVersion } from 'owa-config';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

// The name of the client
export const WAC_OUTLOOK = 'WAC_Outlook_React';

export default function generateTelemetryData(
    eventName: string,
    cardDetails: CardDetails,
    isGroupMessage: boolean,
    messageContext: MessageContext,
    correlationVector?: string,
    genericInfo?: string
    /*isHttpPostActionAvailable: boolean*/ // TODO: re-add this parameter when I find a way to get this information
): any {
    let timeZoneOffset: number = 0;
    let timeZoneName: string;
    const userConfiguration = getUserConfiguration();
    const timeZoneOffsets = userConfiguration.UserOptions.MailboxTimeZoneOffset;
    if (timeZoneOffsets && timeZoneOffsets.length > 0) {
        if (timeZoneOffsets[0].OffsetRanges && timeZoneOffsets[0].OffsetRanges.length > 0) {
            timeZoneOffset = timeZoneOffsets[0].OffsetRanges[0].Offset;
            timeZoneName = timeZoneOffsets[0].TimeZoneId;
        }
    }

    const userCulture = userConfiguration.SessionSettings.UserCulture;
    let clientTelemetry = {
        clientType: WAC_OUTLOOK,
        eventName: eventName,
        culture: userCulture,
        uiCulture: userCulture,
        mailboxType: isGroupMessage ? 'Group' : 'User',
        correlationVector: correlationVector || getCorrelationVector(),
        clientVersion: getClientVersion(),
        externalDirectoryUserGuid: userConfiguration.SessionSettings.ExternalDirectoryUserGuid,
        externalDirectoryTenantGuid: userConfiguration.SessionSettings.ExternalDirectoryTenantGuid,
        timeZone: {
            type: 'Windows',
            id: timeZoneName,
            offsetInMinutes: timeZoneOffset,
        },
        originator: cardDetails.card.originator,
        providerAccountUniqueId: cardDetails.providerAccountUniqueId,
        // isHttpPostActionAvailable: isHttpPostActionAvailable, // TODO: re-add this parameter when I find a way to get this information
        messageType: cardDetails.isAdaptiveCard
            ? ConnectorActionCardType.AdaptiveCard.toString()
            : ConnectorActionCardType.ExplicitMessageCard.toString(),
        messageCardExtensionContext: cardDetails.messageCardExtensionContext,
        messageCardContext: cardDetails.card.messageCardContext,
        genericInfo: genericInfo,
    };

    if (messageContext) {
        const messageDetails = getMessageDetailsForTelemetry(messageContext, isGroupMessage);
        clientTelemetry = { ...clientTelemetry, ...messageDetails };
    }

    return clientTelemetry;
}

function getMessageDetailsForTelemetry(
    messageContext: MessageContext,
    isGroupMessage: boolean
): any {
    const messageDetails = {} as any;
    if (messageContext) {
        messageDetails.senderAddress = messageContext.senderAddress;
        messageDetails.isGroupEscalationMessage = messageContext.isGroupEscalationMessage;

        if (isGroupMessage) {
            messageDetails.threadId = messageContext.conversationId;
            messageDetails.conversationId = messageDetails.conversationId;
            messageDetails.postId = messageContext.itemId;
            messageDetails.messageId = messageDetails.itemId;
        } else {
            messageDetails.messageId = messageContext.itemId;
            messageDetails.conversationId = messageContext.conversationId;
        }
    }

    return messageDetails;
}
